/**
 * demoCatalog.ts — Catálogo de paquetes demo por categoría.
 *
 * Agrupa productos mock por categoriaId para cargar demos selectivos
 * desde Inventario (elegir qué nichos cargar).
 */
import { defaultCategories } from "../products";
import { all_category_products } from "./index";

export interface DemoCatalogPack {
  id: string;
  nombre: string;
  productos: typeof all_category_products;
}

/** Paquetes demo con al menos un producto. */
export const DEMO_CATALOG_PACKS: DemoCatalogPack[] = defaultCategories
  .map((cat) => ({
    id: cat.id,
    nombre: cat.nombre,
    productos: all_category_products.filter((p) => p.categoriaId === cat.id),
  }))
  .filter((pack) => pack.productos.length > 0);

export const ALL_DEMO_PRODUCT_IDS = new Set(
  all_category_products.map((p) => p.id as string),
);

export const getDemoProductsForPackIds = (
  packIds: string[],
): typeof all_category_products => {
  const idSet = new Set(packIds);
  return DEMO_CATALOG_PACKS.filter((p) => idSet.has(p.id)).flatMap(
    (p) => p.productos,
  );
};

/** Devuelve los productos demo exactos por sus ids (selección a nivel de ítem). */
export const getDemoProductsForIds = (
  productIds: string[],
): typeof all_category_products => {
  const idSet = new Set(productIds);
  return all_category_products.filter((p) => idSet.has(p.id as string));
};
